import React from 'react'
import SmsLegalDocument from '../components/SmsLegalDocument'

export default function SmsPrivacyPolicy() {
  return <SmsLegalDocument document="privacy" />
}
